// App.js
import React, { useState, useEffect } from 'react';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import LoginForm from "./Login";
import ChangePassword from "./ChangePassword";
import Dashboard from './SuperAdmin/Dashboard';
import ManageAdmin from './SuperAdmin/ManageAdmin';
import ManageOrganization from './SuperAdmin/ManageOrganization';
import CreateAdmin from './SuperAdmin/CreateAdmin';
import CreateOrganization from './SuperAdmin/CreateOrganization';
import CreateDevice from './SuperAdmin/CreateDevice';
import CreateCard from './SuperAdmin/CreateCard';
import AdminDashboard from './Admin/AdminDashboard';
import AdminRecharge from './Admin/Recharge';
import FloatingMenu from './FloatingMenu';
import Organization from './SuperAdmin/organization'
import ManageBranch from './SuperAdmin/MangeBranch';
import AdminManageOrganization from './Admin/ManageOrganization';
import AdminOrganization from './Admin/organization'
import AdminManageBranch from './Admin/ManageBranch'
import AdminCreateOrganization from './Admin/CreateOrganization'
import AdminTransactions from './Admin/TransactionHistory'
import SuperAdminTransactions from './SuperAdmin/TransactionHistory'
import SuperAdminRecharge from './SuperAdmin/Recharge'
import BranchUserDashboard from './BranchUser/branchUserDashboard'
import BranchUserTransactions from './BranchUser/UserTransactions'
import BranchUserManageBranch from './BranchUser/ManageBranch'
import AdminSuperCreateOrganization from './SuperAdmin/AdminCreateOrganization'
import SuperAdminCallingReport from './SuperAdmin/CallingReport';
import SearchCardsandDevices from './SuperAdmin/SearchCardsAndDevices'
import BranchCardManagement from './BranchUser/CardManagement'
import UserCardTransactionHistory from './BranchUser/CardTransactions';
import SearchCards from './BranchUser/SearchCards';
import StudentCallsTransactionHistory from './BranchUser/StudentCalls';
import StudentTransactionHistory from './BranchUser/StudentTransactions';
import StudentCallLogs from './BranchUser/StudentCallLogs'
function App() {
  const [IsLoading, setIsLoading] = useState(false);
  const [userName, setUserName] = useState('');
  const location = useLocation();
  const hideFloatingMenuOnRoutes = ['/', '/ChangePassword'];
  const shouldShowFloatingMenu = hideFloatingMenuOnRoutes.includes(location.pathname);

  const navigate = useNavigate();
  const logout = () => {
      console.log(localStorage.removeItem('jwtToken'));
      localStorage.removeItem('jwtToken');
      console.log(localStorage.removeItem('jwtToken'));
      navigate("/");
  };
  useEffect(() => {
    setUserName(localStorage.Loginname);
});
  return (
    
    //  <div>
    //   <LoginForm />
    //   <RegistrationForm />
    
    //  </div>
    
      <div id="menuoff" className="handle-leftNav">
        
           <div className="left-nav">
                {/* <a href="..\Dashboard"><img src={loginlogo} width="55px" /></a> */}

                <ul className="navbar-nav me-auto mb-2 mt-3 mb-lg-0">
                  
                    {/* <li className="nav-item">
    //                     <a className="nav-link" href="..\Dashboard">
    //                         <i class='fas fa-signal'></i>  Dashboard
    //                     </a>
    //                 </li> */}
                    {/* <li className="nav-item">
    //                     <a className="nav-link" href="..\ApprovalList">
    //                         <i class='fas fa-signal'></i>  Approval Client Access
    //                     </a>
    //                 </li> */}
                    {/* <li className="nav-item">
    //                     <a className="nav-link" href="..\DeltaProcess">
    //                         <i class='far fa-newspaper'></i> Delta NIK
    //                     </a>
    //                 </li> */}
    
                 </ul>

            </div>
           <div className="nav-top text-end p-2" id="header">
            {/* <div className="px-3 mt-3 bb-m"><span className="balance-title">Settings</span></div> */}
               {/* <span className="pe-5 span-title" id="Dashboardheader">APPROVAL NEW USER LIST</span> */}
              
               <a className="nav-link user-tile" href="#" onClick={logout}>
                 <span className="user-name">{userName}</span>
                    <i className="fas fa-power-off"></i>
                </a>
           </div>
            <div className="right-container">
          <Routes>
               <Route exact index path="/" element={<LoginForm />} />
               {/* <Route path="RegistrationForm" element={<RegistrationForm />} /> */}
               <Route exact path="/ChangePassword" element={<ChangePassword />} />
               <Route path="/SuperAdmin/Dashboard" element={<Dashboard />} />
               <Route path="/SuperAdmin/ManageAdmin" element={<ManageAdmin />} />
               <Route path="/SuperAdmin/ManageOrganization" element={<ManageOrganization />} /> 
               <Route path="/SuperAdmin/CreateAdmin" element={<CreateAdmin />} /> 
               <Route path="/SuperAdmin/CreateOrganization" element={<CreateOrganization />} /> 
               <Route path="/SuperAdmin/CreateDevice" element={<CreateDevice />} /> 
               {/* <Route path="/SuperAdmin/CreateCard" element={<CreateCard />} />  */} 
               <Route path="/Admin/AdminDashboard" element={<AdminDashboard />} /> 
               <Route path="/Admin/Recharge" element={<AdminRecharge />} /> 
               <Route path="/SuperAdmin/Organization/:id" element={<Organization />} />
               <Route path="/SuperAdmin/ManageBranch/:branch_id/:organization_id"element={<ManageBranch />}/>
               {/* Admin */}
               <Route path="/Admin/ManageOrganization" element={<AdminManageOrganization />} />
               <Route path="/Admin/Organization/:id" element={<AdminOrganization />} />
               <Route path="/Admin/ManageBranch/:branch_id/:organization_id"element={<AdminManageBranch />}/>
               <Route path="/Admin/CreateOrganization" element={<AdminCreateOrganization />} /> 
               <Route path ="/Admin/TransactionHistory" element = {<AdminTransactions/>}/>
               <Route path ="/SuperAdmin/TransactionHistory" element = {<SuperAdminTransactions/>}/>
               <Route path="/SuperAdmin/Recharge" element={<SuperAdminRecharge />} />
               <Route path="/BranchUser/BranchUserDashboard" element={<BranchUserDashboard />} />
               <Route path ="/BranchUser/TransactionHistory" element = {<BranchUserTransactions/>}/>
               <Route path="/BranchUser/ManageBranch/:branch_id/:organization_id"element={<BranchUserManageBranch />}/>
               <Route path="/SuperAdmin/CreateOrganization/:adminid"element={<AdminSuperCreateOrganization />}/>
               <Route path="/SuperAdmin/CallingReport" element={<SuperAdminCallingReport />} />
               <Route path="/SuperAdmin/SearchCardsandDevices" element={<SearchCardsandDevices/>}/>
               <Route path ="/BranchUser/CardManagement" element = {<BranchCardManagement/>}/>
               <Route path="/BranchUser/CardManagement/Transactions" element = {<UserCardTransactionHistory/>}/>
               <Route path="/BranchUser/CardManagement/SearchCards" element = {<SearchCards/>}/>
               <Route path="/BranchUser/CardManagement/StudentTransactions/:user_id" element={<StudentTransactionHistory />} />
               <Route path="/BranchUser/CardManagement/StudentCallLogs/:user_id" element={<StudentCallLogs />} />
               <Route path="/BranchUser/CardManagement/StudentCallTransactions/:id" element={<StudentCallsTransactionHistory />} />
              </Routes>
              </div>

           <footer><center ><font size="2"><i class="fa-solid fa-copyright"></i> Max Card | version 1.0 | {new Date().getFullYear()}</font>  </center></footer>
        {/* 👇 Add FloatingMenu here */}
       {
       !shouldShowFloatingMenu && (
        <FloatingMenu 
          onLogout={logout}
          onChangePassword={ChangePassword}
        />
      )}
        </div>
  );
}

export default App;
